import React from 'react';

import { MainEngineStarted } from 'screens/shared';

const DieselMainEngineStarted = () => (
  <MainEngineStarted
    initialRpmValue="1400"
    iconLeft="icon-xm-bar-flasks"
    iconRight="icon-xm-temp-bar"
    engineType="diesel"
  />
);

export default DieselMainEngineStarted;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselIdle/DieselMainEngineStarted.js